/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Support_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic preparation" |
*
* @param {Team_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_support_title = /** @type {((inputs?: Team_Support_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Support_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Automatische voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation automatique")
	return /** @type {LocalizedString} */ ("Automatic preparation")
});